import { MarkdownRenderer } from '@/components/MarkdownRenderer'
import { MentionRenderer } from '@/components/ui/mention-renderer'
import { ChatMessage } from '../../state/types'

interface MessageItemProps {
  message: ChatMessage
}

export function MessageItem({ message }: MessageItemProps) {
  return (
    <div
      className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}
    >
      <div
        className={`max-w-[70%] rounded-lg p-3 ${
          message.role === 'user'
            ? 'bg-primary text-primary-foreground'
            : 'bg-muted text-foreground'
        }`}
      >
        {message.role === 'user' ? (
          <MentionRenderer content={message.content} className="text-sm" />
        ) : (
          <MarkdownRenderer content={message.content} />
        )}
        <p className="text-xs opacity-70 mt-1">
          {new Date(message.timestamp).toLocaleTimeString()}
        </p>
      </div>
    </div>
  )
} 